/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AnalyticTable from 'components/kea/tables/AnalyticTable';
import CardContainer from 'components/kea/CardContainer';
import { getRelatedProductsByPurchase } from 'actions';
import { linkToProductDetail } from 'util/appUtils';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const RelatedProductsByPurchase = ({ productId }) => {
  const localizeMessage = useLocalizedMessage();
  const dispatch = useDispatch();
  const { analytics: { products, timeframe }, app: { currentShop } } = useSelector((str) => str);
  const { relatedByPurchase: { isFetching, data, error } } = products;
  useEffect(() => {
    dispatch(getRelatedProductsByPurchase(currentShop, timeframe, productId));
  }, [timeframe, productId]);

  const headCells = [
    {
      id: 'name',
      numeric: false,
      label: localizeMessage('analytics.table.productName'),
      sortKey: 'nameText',
    },
    { id: 'count', numeric: true, label: localizeMessage('analytics.table.purchases') },
  ];

  const prepareData = (rows) => rows.map((e) => ({
    ...e,
    nameText: e.name,
    name: linkToProductDetail(currentShop, e.name, e.id),
  }));

  return (
    <CardContainer
      headerId="search.analytics.relatedProductsByPurchase.header"
      styleName="noMargin"
      tableSurface
      isFetching={isFetching}
      error={error}
    >
      <AnalyticTable
        rows={prepareData(data)}
        headCells={headCells}
        orderById="count"
        emptyMessageId="analytics.product.relatedPurchases.empty"
      />
    </CardContainer>
  );
};

export default RelatedProductsByPurchase;
